import { datadogRum } from "@datadog/browser-rum";
import appConst from "./appConst.json";

export const getNativeContext = () => {
  try {
    return {
      platform: sessionStorage.getItem(appConst.PLATFORM), // ios | android | web
      device: sessionStorage.getItem(appConst.DEVICE),
      sourceDevice: sessionStorage.getItem(appConst.SOURCE_DEVICE),
      hasToken: Boolean(sessionStorage.getItem(appConst.TOKEN)),
    };
  } catch {
    return {};
  }
};

// Entry diagnostics that explain HOW the user reached the point of failure.
// Auto-merged into every tracked error (see trackError).
export const getDiagnosticContext = () => {
  try {
    const navEntry =
      (typeof performance !== "undefined" &&
        performance.getEntriesByType &&
        performance.getEntriesByType("navigation")[0]) ||
      null;
    return {
      route: window.location.pathname, // route that fired the error
      url: window.location.href, // full URL incl. query params
      referrer: document.referrer || null, // where they came from
      navigationType: navEntry ? navEntry.type : null, // navigate | reload | back_forward
      msSincePageLoad: Math.round(performance.now()), // how early it fired (race signal)
      visibility: document.visibilityState, // visible | hidden (webview backgrounded?)
    };
  } catch {
    return {};
  }
};

// Send an error to Datadog with custom context. Datadog auto-enriches every error
// with device.type / os / browser / geo, so each one already tells you the device.
// Never lets monitoring throw into the app.
export const trackError = (error, context = {}) => {
  try {
    const errorObj =
      error instanceof Error
        ? error
        : new Error(typeof error === "string" ? error : "Non-Error thrown");

    if (datadogRum && datadogRum.addError) {
      datadogRum.addError(errorObj, {
        ...getNativeContext(),
        ...getDiagnosticContext(),
        ...context,
      });
    }
  } catch {
    // swallow — monitoring must never break checkout
  }
};
